<template>
  <Modal class="slider-editor-new-item-modal">
    <div class="modal-header">
      <h5>สร้างสไลด์ใหม่</h5>
      <button
        class="btn-close"
        @click.stop="$emit('update:showAddSliderItemModal', false)">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="left-or-right-container">
      <div
        class="left-or-right-selector selector--left"
        @click.stop="newBlankSlide">
        <i class="far fa-sticky-note"></i>
        <p>สร้างสไลด์เปล่า</p>
      </div>
      <div
        class="left-or-right-selector selector--right"
        @click.stop="showLoadFromAPIModal">
        <i class="fas fa-folder-open"></i>
        <p>เลือกข้อมูลจากระบบ</p>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
  props: {
    showAddSliderItemModal: {
      type: Boolean,
      default: () => false,
    },
    allItems: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    Modal,
  },
  methods: {
    newBlankSlide() {
      const newSlide = {
        title: 'Untitled slide',
        coverImage: null,
        contentCategory: null,
        link: {
          url: '',
          target: '_blank',
        },
        parentId: null,
        parentType: null,
        syncWithParent: false,
        startPublish: new Date(),
        endPublish: null,
      };
      this.$emit('update:allItems', [newSlide, ...this.allItems]);
      this.$emit('update:showAddSliderItemModal', false);
    },
    showLoadFromAPIModal() {
      this.$emit('update:showAddSliderItemModal', false);
      this.$emit('showLoadFromAPIModal');
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';

.slider-editor-new-item-modal {
  .btn-close {
    position: absolute;
    top: 16px;
    right: 10px;
    background: transparent;
    border: none;
    outline: none;
    transition: color 250ms ease;
    color: $gray-700;
    &:hover {
      color: $red;
    }
  }
  .left-or-right-container {
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: center;

    .left-or-right-selector {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-flow: column;
      width: 50%;
      padding: 30px 0;
      transition: all 250ms ease;

      i {
        font-size: 60px;
        margin: 10px 0;
      }

      &:hover {
        background: $gray-200;
      }
    }

    .selector--left {
      border-right: 1px dashed $gray-400;
    }
  }
}
@media screen and (max-width: 575.98px) {
  .slider-editor-new-item-modal {
    .left-or-right-container {
      flex-flow: column;
      .left-or-right-selector {
        width: 100%;
        padding: 10px 0;
      }
      .selector--left {
        border-right: none;
        border-bottom: 1px dashed #ced4da;
      }
    }
  }
}
</style>
